import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { db } from "./firebase";

import {
  collection,
  onSnapshot,
  addDoc,
deleteDoc,
doc,
getDocs,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";


const C = {
  bg: "#0a0a0f",
  surface: "rgba(255,255,255,0.04)",
  surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)",
  text: "#f5f5f7",
  secondary: "rgba(245,245,247,0.6)",
  accent: "#0a84ff",
  green: "#30d158",
  orange: "#ff9f0a",
  red: "#ff453a",
};

export default function GestioneDemo() {

  const [demoMenus, setDemoMenus] = useState([]);
  const [loading, setLoading] = useState(true);

  // realtime demo menus
  useEffect(() => {

    const unsub = onSnapshot(
      collection(db, "demoMenus"),
      (snap) => {

        const lista = snap.docs.map(d => ({
          id: d.id,
          ...d.data()
        }));

        setDemoMenus(lista);
        setLoading(false);

      }
    );

    return () => unsub();

  }, []);

  // crea demo
  const creaDemo = async () => {
    const nome = prompt("Nome demo");
    if (!nome) return;


    // Genera localeTag leggendo dal nome
    const localeTag =
      "demo_" +
      nome
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^a-z0-9_]/g, "");

    try {

      // crea vero locale demo
      await setDoc(doc(db, "locali", localeTag), {
  nome,
  localeTag,

  stato: "attivo",

  isDemoTemplate: true,
  tipoDemo: nome.toLowerCase(),

  // ===== AI =====
  assistenteAI: true,
  suggerimentiAI: true,
  adminSuggerimentiAI: true,

  // ===== FOTO MENU =====
  menuConFoto: true,
  adminMenuConFoto: true,

  // ===== TRADUZIONI =====
  translationEnabled: true,
  lingueAbilitate: [
  "it",
  "en",
  "fr",
  "de",
  "es"
],

defaultLanguage: "it",

  // ===== FUNZIONI =====
  consentOrdine: true,
  consentChiamataCameriere: true,
  mostraSelezioneLingue: true,

  // ===== STAMPA =====
  stampaAutomaticaOrdini: false,

  // ===== DASHBOARD =====
  nascondiAI: false,
  nascondiCassa: false,
  nascondiCucina: false,
  nascondiOrdini: false,
  nascondiModificaMenu: false,
  nascondiStatoTavoli: false,
  nascondiCamerieri: false,

  // ===== TAVOLI =====
  numeroTavoli: 20,

  sale: [
    {
      lettera: "A",
      numeroTavoli: 10
    }
  ],

  createdAt: serverTimestamp(),
});

// ===== CREDITI AI IMMAGINI =====
await setDoc(
  doc(db, "aiCredits", localeTag),
  {
    credits: 20,
    enabled: true,
    maxCreditsAllowed: 20
  }
);

// ===== CREDITI AI TRADUZIONI =====
await setDoc(
  doc(db, "restaurants", localeTag, "ai", "translations"),
  {
    translationCredits: 500,
    enabled: true,
    updatedAt: new Date()
  }
);

      await addDoc(collection(db, "demoMenus"), {
        nome,
        localeTag,
        tipo: nome.toLowerCase(),
        attiva: true,
        isDemoTemplate: true,
        menuCreato: false,
        createdAt: serverTimestamp(),
      });

    } catch (err) {

      console.error(err);

    }

  };

  // elimina demo
const eliminaDemo = async (id, localeTag) => {

  const ok = window.confirm(
    "Eliminare questa demo?"
  );

  if (!ok) return;

  try {

    // 🔥 elimina tavoli
    const tavoliSnap = await getDocs(
      collection(db, "locali", localeTag, "tavoli")
    );

    for (const d of tavoliSnap.docs) {
      await deleteDoc(d.ref);
    }

    // 🔥 elimina piatti menu
    const menuSnap = await getDocs(
      collection(db, "menu")
    );

    for (const d of menuSnap.docs) {

      const data = d.data();

      if (
  data.localeTag === localeTag ||
  data.locale === localeTag ||
  data.ristoranteId === localeTag
) {
        await deleteDoc(d.ref);
      }

    }

    // 🔥 elimina locale
    await deleteDoc(
      doc(db, "locali", localeTag)
    );

    // 🔥 elimina demoMenus
    await deleteDoc(
      doc(db, "demoMenus", id)
    );

  } catch (err) {

    console.error(err);

  }

};

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.bg,
        color: C.text,
        fontFamily:
          "-apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >

      <Navbar />

      <div
        className="page-with-navbar"
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >

        {/* HERO */}

        <div
          style={{
            marginBottom: "2rem",
          }}
        >

          <p
            style={{
              color: C.secondary,
              marginBottom: "0.4rem",
              fontSize: "0.8rem",
            }}
          >
            Sistema Demo
          </p>

          <h1
            style={{
              fontSize: "2rem",
              margin: 0,
              fontWeight: 700,
              letterSpacing: "-1px",
            }}
          >
            🎭 Gestione Demo
          </h1>

        </div>

        {/* ACTION BAR */}

        <div
          style={{
            display: "flex",
            gap: "0.8rem",
            marginBottom: "2rem",
          }}
        >

          <button
            onClick={creaDemo}
            style={{
              background: C.accent,
              border: "none",
              color: "#fff",
              padding: "0.9rem 1.2rem",
              borderRadius: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            + Nuova Demo
          </button>

        </div>

        {/* GRID */}

        {loading ? (

          <p>Caricamento...</p>

        ) : (

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fill,minmax(280px,1fr))",
              gap: "1rem",
            }}
          >

            {demoMenus.map((demo) => (

              <div
                key={demo.id}
                style={{
                  background: C.surface,
                  border: `1px solid ${C.border}`,
                  borderRadius: "24px",
                  padding: "1.2rem",
                }}
              >

                {/* HEADER */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "1rem",
                  }}
                >

                  <div>

                    <h2
                      style={{
                        margin: 0,
                        fontSize: "1.05rem",
                      }}
                    >
                      {demo.nome}
                    </h2>

                    <p
                      style={{
                        margin: "0.35rem 0 0 0",
                        color: C.secondary,
                        fontSize: "0.8rem",
                      }}
                    >
                      {demo.tipo}
                    </p>

                  </div>

                  <div
                    style={{
                      background: demo.attiva
                        ? "rgba(48,209,88,0.15)"
                        : "rgba(255,69,58,0.15)",

                      color: demo.attiva
                        ? C.green
                        : C.red,

                      padding: "0.35rem 0.7rem",

                      borderRadius: "999px",

                      fontSize: "0.7rem",

                      fontWeight: 700,
                    }}
                  >
                    {demo.attiva
                      ? "ATTIVA"
                      : "OFF"}
                  </div>

                </div>

                {/* ACTIONS */}

                <div
                  style={{
                    display: "flex",
                    gap: "0.6rem",
                    flexWrap: "wrap",
                  }}
                >

                  <button
                    style={btnStyle(C.accent)}
                    onClick={() => {
                      window.location.href =
                        `/demo-menu-editor/${demo.localeTag}`;
                    }}
                  >
                    Apri
                  </button>

                  <button
  style={btnStyle(C.orange)}
  onClick={() => {

    localStorage.setItem(
      "forcedLocale",
      demo.localeTag
    );

    window.open(
      `/dashboard-gestore?locale=${demo.localeTag}`,
      "_blank"
    );

  }}
>
  Dashboard
</button>

                  <button
                    onClick={() => eliminaDemo(
  demo.id,
  demo.localeTag
)}
                    style={btnStyle(C.red)}
                  >
                    Elimina
                  </button>

                </div>

              </div>

            ))}

          </div>

        )}

      </div>

    </div>
  );
}

function btnStyle(color) {

  return {

    background: `${color}22`,

    color,

    border: "none",

    padding: "0.7rem 1rem",

    borderRadius: "12px",

    fontWeight: 600,

    cursor: "pointer",

    fontSize: "0.82rem",

  };

}